import { render } from "./ShariaBadge.vue?vue&type=template&id=0a223b6f&scoped=true"
import script from "./ShariaBadge.vue?vue&type=script&lang=js"
export * from "./ShariaBadge.vue?vue&type=script&lang=js"

import "./ShariaBadge.vue?vue&type=style&index=0&id=0a223b6f&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a223b6f"]])

export default __exports__